import { useEffect, useRef, useState } from "react";
import { X } from "lucide-react";

const CONFIRM_MS = 5000;

export function BacklogRejectButton({ code, onReject }: { code: string; onReject: () => void }) {
  const [armed, setArmed] = useState(false);
  const timer = useRef<number | null>(null);

  const clear = () => {
    if (timer.current !== null) window.clearTimeout(timer.current);
    timer.current = null;
  };
  useEffect(() => clear, []);

  const disarm = () => {
    clear();
    setArmed(false);
  };
  const arm = () => {
    clear();
    setArmed(true);
    timer.current = window.setTimeout(() => setArmed(false), CONFIRM_MS);
  };

  if (!armed) {
    return (
      <button
        type="button"
        onClick={arm}
        title="Reject — the task is deleted"
        aria-label={`Reject ${code}`}
        className="border-border text-muted-foreground inline-flex h-7 w-[62px] items-center justify-center rounded-lg border text-[11px] font-bold hover:border-[oklch(0.62_0.22_25_/_0.5)] hover:text-[oklch(0.5_0.19_25)]"
      >
        Reject
      </button>
    );
  }

  return (
    <>
      <button
        type="button"
        onClick={() => {
          disarm();
          onReject();
        }}
        aria-label={`Confirm rejecting ${code} — it will be deleted`}
        className="inline-flex h-7 items-center rounded-lg border border-[oklch(0.62_0.22_25_/_0.5)] px-2 text-[11px] font-bold text-[oklch(0.5_0.19_25)]"
      >
        Sure?
      </button>
      <button
        type="button"
        onClick={disarm}
        aria-label={`Keep ${code}`}
        className="text-muted-foreground hover:text-foreground p-1"
      >
        <X className="size-3.5" aria-hidden />
      </button>
    </>
  );
}
